<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";

const currentPosition = ref(0);
let intervalId: ReturnType<typeof setTimeout> | null = null;

function nextPost(direction: string, handleClick?: string) {
	if (handleClick == "click") {
		stopAutoScroll();
	}

	const container = document.querySelector(".section ul") as HTMLElement;
	if (container) {
		const step = direction === "l" ? 50 : -50;
		currentPosition.value += step;

		// Check if reached the end
		if (currentPosition.value > 0) {
			currentPosition.value = -(container.childElementCount - 2) * 50;
		} else if (
			currentPosition.value <
			-(container.childElementCount - 2) * 50
		) {
			currentPosition.value = 0;
		}

		container.style.transform = `translateX(${currentPosition.value}vw)`;
	}
}

function startAutoScroll() {
	intervalId = setInterval(() => {
		nextPost("r");
	}, 3000);
}

function stopAutoScroll() {
	if (intervalId) {
		clearInterval(intervalId);
		intervalId = null;
	}
}

onMounted(() => {
	startAutoScroll();
});

onUnmounted(() => {
	stopAutoScroll();
});
</script>

<template>
	<div class="section">
		<ul>
			<li>
				<img src="@/assets/image/partners/partner2.png" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner1.png" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner3.png" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner4.png" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner5.png" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner6.svg" alt="partner" />
			</li>
			<li>
				<img src="@/assets/image/partners/partner7.jpg" alt="partner" />
			</li>
		</ul>
		<div class="left" @click="nextPost('l', 'click')">
			<img
				src="@/assets/image/icons/arrow-left.svg"
				alt="icon"
				loading="lazy"
			/>
		</div>
		<div class="right" @click="nextPost('r', 'click')">
			<img
				src="@/assets/image/icons/arrow-right.svg"
				alt="icon"
				loading="lazy"
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
$section-background: #f1d7aca8;
.section {
	position: relative;
	overflow: hidden;
	.left,
	.right {
		position: absolute;
		height: 80%;
		aspect-ratio: 1 / 1;
		background-color: $section-background;
		top: 50%;
		transform: translateY(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			max-width: 40%;
			z-index: 10;
		}

		&:hover {
			background-color: $app-accent-color1;
		}
	}

	.left {
		left: 1%;
	}

	.right {
		left: 25%;
	}

	ul {
		display: flex;
		transition: transform 0.5s ease;
		transform: translateX(0);
		li {
			width: 50vw;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				max-width: 90%;
				max-height: 100%;
			}
		}
	}
}
</style>
